import React, { Component } from 'react'

import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import * as Actions from "../../../../store/modules/code";
import * as FActions from "../../../../store/modules/footer";
import CCodeItem from "./module/cCodeItem";
import * as func from "../../../../utils/functions";
import PCodeItem from "./module/pCodeItem";

class ChildrenCode extends Component {
  constructor(props) {
    super(props);

    this.state = {
      editIndex : ''
    }

    this.onInsert = this.onInsert.bind(this);
    this.onUpdate = this.onUpdate.bind(this);
    this.onRemove = this.onRemove.bind(this);
    this.changeView = this.changeView.bind(this);
    this.showMessage = this.showMessage.bind(this);
    this.onEditIndex = this.onEditIndex.bind(this);
  }

  onInsert() {
    const insertRecord = {
      'up_code_id' : this.props.selectChildCodeId,
      'code_id': '',
      'code_name': '',
      'code_desc': '',
      'code_name_eng': '',
      'del_yn': "N",
      'depth_level': 1,
      'disp_yn': "Y",
      'map_code': '',
      'visible_seq': '0',
      'is_edit': true,
    }
    const childRecords = [...this.props.childRecords];
    if (childRecords.length > 0 && childRecords[0].code_id === '') {
      this.showMessage('추가해주세요.')
    } else {
      this.onEditIndex(0);
      childRecords.unshift(insertRecord);
      this.props.dataActions.setCode({'childRecords': childRecords});
    }
  }

  onEditIndex(id) {
    if(this.state.editIndex && this.refs["ref" + this.state.editIndex])
      this.refs["ref" + this.state.editIndex].onClose();
    else if(this.refs.ref)
      this.refs.ref.onClose();
    else if(this.refs["ref" + this.state.editIndex])
      this.refs["ref" + this.state.editIndex].onClose();
    this.setState({
      'editIndex' : id
    })
  }

  onUpdate(index, record, render) {
    const childRecords = [...this.props.childRecords];
    childRecords[index] = record;
    this.props.dataActions.setCode({'childRecords': childRecords});
		if(render)
			this.forceUpdate();
  }

  onRemove(index) {
    const childRecords = [...this.props.childRecords];
    childRecords.splice(index, 1);
    this.props.dataActions.setCode({'childRecords': childRecords});
  }

  changeView() {
    let param = this.props.param;
    if (param.del_yn === 'Y') {
      param.del_yn = 'N';
    } else if (param.del_yn === 'N') {
      param.del_yn = 'Y';
    }

    setTimeout(() => {
      func.getData("code", param).then((response) => {
        this.props.dataActions.setCode({"param": param});
        response.childRecords = response.records;
        delete response.records;
        this.props.dataActions.setCode(response);
      });
    }, 0);
  }

  showMessage(message) {
    this.props.fDataActions.setFooter({
      'isNoticePopup': true,
      'noticeMessage': message
    })
    setTimeout(() => {
      this.props.fDataActions.setFooter({
        'isNoticePopup': false,
        'noticeMessage': ''
      })
    }, 3000);
  }

  render() {
    const {childRecords} = this.props;

    console.log(childRecords)

    return (
      <div className="p-0">
        <div className="d-flex justify-content-end mb-1">
          <span className="flex-grow-1 font-weight-bold align-bottom">{this.props.selectChildCodeId} 코드 목록</span>
          <button type="button" className="btn btn-sm btn-primary" onClick={this.onInsert}>추가</button>
        </div>
        <div className="card mt-0 p-0 maxWidthInit">
          <table className="table table-thin border-bottom mb-0">
            <colgroup>
              {/*<col width="40px"/>*/}
              <col width="50px"/>
              <col width="100px"/>
              <col width="150px"/>
              <col width="50px"/>
              <col width="70px"/>
              <col width="100px"/>
            </colgroup>
            <thead>
            <tr>
              {/*<th scope="col">번호</th>*/}
              <th scope="col">코드ID</th>
              <th scope="col">코드명</th>
              <th scope="col">영문명</th>
              <th scope="col">사용</th>
              <th scope="col">정렬순서</th>
              <th scope="col">액션</th>
            </tr>
            </thead>
            <tbody>
              {childRecords.map((record, index) => {
                return (
                  <CCodeItem
                    key={record.code_id}
                    index={record.code_id}
                    ref={"ref" + record.code_id}
                    arrIndex={index}
                    record={record}
                    selectChildCodeId={this.props.selectChildCodeId}
                    onUpdate={this.onUpdate}
                    onRemove={this.onRemove}
                    onEditIndex={this.onEditIndex}
                    showMessage={this.showMessage}
                    onChildrenCode={this.onChildrenCode}
                  />
                )
              })}
              {childRecords.length <= 0 &&
                <tr><td colSpan="6">코드가 없습니다.</td></tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    )
  }
}

export default connect(
  (state) => ({
    childRecords: state.code.childRecords ? state.code.childRecords : [],
    selectChildCodeId: state.code.selectChildCodeId ? state.code.selectChildCodeId : [],
  }),
  (dispatch) => ({
    dataActions: bindActionCreators(Actions, dispatch),
    fDataActions: bindActionCreators(FActions, dispatch)
  }),
)(ChildrenCode)

// ParentCode.propTypes = {
// 	param: PropTypes.object,
// 	childRecords: PropTypes.array,
// 	// facet: PropTypes.object,
// 	// totalRecords: PropTypes.number,
// 	// totalPage: PropTypes.number,
// };
